import map from 'lodash.map';
import React from 'react';
import SwiperCore, { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IArticlesData, IArticlesItem } from 'constants/types';
import Loader from 'components/Loader/Loader';
import ArticlesCard, { ArticlesType } from 'components/Articles/card/ArticlesCard';
import get from 'lodash.get';
import { ArticlesSliderMainWrap } from './ArticlesSliderMainStyles';

// Styles
const settings = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerGroup: 1,
  autoplay: false,
  centeredSlides: false,
  scrollbar: {
    draggable: true,
  },
  watchSlidesVisibility: true,
  preloadImages: false,
  breakpoints: {
    500: {
      spaceBetween: 24,
      slidesPerView: 2,
      slidesPerColumn: 1,
      slidesPerGroup: 1,
    },
    900: {
      spaceBetween: 24,
      slidesPerView: 3,
      slidesPerColumn: 2,
      slidesPerGroup: 1,
    },
    1024: {
      slidesPerView: 3,
      slidesPerColumn: 2,
      slidesPerGroup: 3,
      spaceBetween: 24,
    },
    1250: {
      slidesPerView: 4,
      slidesPerColumn: 2,
      slidesPerGroup: 4,
      spaceBetween: 24,
    },
  },
};

// Interfaces
interface IArticlesSliderMain {
  data: IArticlesData
  type: ArticlesType
  loading?: boolean
  isDark?: boolean
}

// Swiper
SwiperCore.use([Scrollbar]);

// Component
const ArticlesSliderMain = (props: IArticlesSliderMain) => {
  const { data, loading, type } = props;

  return (
    <ArticlesSliderMainWrap>
      {loading
        ? <Loader />
        : (
          <Swiper {...settings}>
            {map(data, (item: IArticlesItem) => {
              const id = get(item, ['id']);

              return (
                <SwiperSlide key={id}>
                  <ArticlesCard
                    item={item}
                    type={type}
                    isSlider
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
    </ArticlesSliderMainWrap>
  );
};

ArticlesSliderMain.defaultProps = {
  loading: false,
  isDark: false,
};

export default ArticlesSliderMain;
